import React, { useEffect, useRef } from 'react';
import { Box, Typography, Avatar, CircularProgress, useTheme } from '@mui/material';
import { SmartToy, Person } from '@mui/icons-material';

const ChatMessageList = ({ messages, loading }) => {
  const theme = useTheme();
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, loading]);

  return (
    <Box sx={{ flex: 1, overflowY: 'auto', p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      {messages.map((msg, idx) => {
        const isUser = msg.sender === 'user';
        return (
          <Box 
            key={idx} 
            sx={{ 
              display: 'flex', 
              justifyContent: isUser ? 'flex-end' : 'flex-start',
              alignItems: 'flex-start',
              gap: 1
            }}
          >
            {!isUser && (
              <Avatar 
                sx={{ 
                  bgcolor: 'primary.main', 
                  width: 32, 
                  height: 32 
                }}
              >
                <SmartToy fontSize="small" />
              </Avatar>
            )}
            
            <Box 
              sx={{ 
                maxWidth: '75%',
                bgcolor: isUser ? 'primary.main' : 'white',
                color: isUser ? 'white' : 'text.primary',
                p: 1.5,
                borderRadius: 2,
                borderTopLeftRadius: !isUser ? 0 : 2,
                borderTopRightRadius: isUser ? 0 : 2,
                boxShadow: isUser ? '0 2px 4px rgba(37, 99, 235, 0.2)' : '0 1px 2px rgba(0,0,0,0.05)',
                border: isUser ? 'none' : '1px solid #E2E8F0'
              }}
            >
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                {msg.text}
              </Typography>
            </Box>

            {isUser && (
              <Avatar 
                sx={{ 
                  bgcolor: 'secondary.main', 
                  width: 32, 
                  height: 32 
                }}
              >
                <Person fontSize="small" />
              </Avatar>
            )}
          </Box>
        );
      })}
      
      {loading && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 1 }}>
          <Avatar 
            sx={{ 
              bgcolor: 'primary.main', 
              width: 32, 
              height: 32 
            }}
          >
            <SmartToy fontSize="small" />
          </Avatar>
          <Box 
            sx={{ 
              bgcolor: 'white',
              p: 1.5,
              borderRadius: 2,
              borderTopLeftRadius: 0,
              border: '1px solid #E2E8F0'
            }}
          >
            <CircularProgress size={16} />
          </Box>
        </Box>
      )}
      
      <div ref={messagesEndRef} />
    </Box>
  );
};

export default ChatMessageList;
